const tableConfig = {
  addTooltip: 'Adicionar',
  deleteTooltip: 'Deletar',
  editTooltip: 'Editar',
  filterTooltip: 'Filtrar',
  deleteText: 'Deseja realmente deletar este item?',
  cancelTooltip: 'Cancelar',
  saveTooltip: 'Salvar',
  actions: 'Opções',
  labelRowsSelect: 'itens',
  firstTooltip: 'Início',
  previousTooltip: 'Anterior',
  nextTooltip: 'Próxima',
  lastTooltip: 'Última',
  searchPlaceholder: 'Pesquisar...',
  labelDisplayedRows: 'de'
};

export default tableConfig;
